export default __webpack_public_path__ + "2f879c5f186f9643caca6599a819d3b7.png";